import { Link } from "react-router-dom";
import { Star, CheckCircle2 } from "lucide-react";

const Unsubscribed = () => (
  <main className="grid min-h-screen place-items-center bg-[#FFFDF6] px-4" data-testid="unsubscribed-page">
    <div className="w-full max-w-md rounded-3xl border border-[#E2DDD0] bg-white p-10 text-center shadow-[0_24px_48px_-12px_rgba(14,165,233,0.18)]">
      <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-[#FFC107] shadow-inner">
        <Star className="h-8 w-8 fill-white text-white" />
      </span>
      <h1 className="mt-6 font-display text-2xl font-bold tracking-tight text-slate-900">
        You&apos;re unsubscribed
      </h1>
      <p className="mt-3 flex items-start justify-center gap-2 text-sm leading-relaxed text-slate-600">
        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-[#16A34A]" />
        No more emails from us — promise. Your 7-Day Little Faith Activity Pack is still
        yours to keep and enjoy.
      </p>
      <div className="mt-8 grid gap-3">
        <Link
          to="/free-pack/pack"
          data-testid="unsubscribed-pack-link"
          className="rounded-full bg-slate-900 px-6 py-3 font-display text-sm font-semibold text-white"
        >
          Revisit your pack
        </Link>
        <Link
          to="/"
          data-testid="unsubscribed-home-link"
          className="text-sm font-bold text-slate-500 hover:text-slate-800"
        >
          &larr; Back to Little Songs. Big Faith.
        </Link>
      </div>
    </div>
  </main>
);

export default Unsubscribed;
